import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import Result from '../models/result.model';
import { environment } from '../../environments/environment';

@Injectable(

)
export class BackService {

  baseUrl:string = environment.LoginURL;
  constructor(private http: HttpClient,
   
    ) { }

  public post(body: any): Observable<any> {
    const jwt = localStorage.getItem('jwt')
    const headers = { 
          'Content-Type': 'application/json',
          'Authorization':'Bearer '+ jwt
        };

    const json = JSON.stringify(body);   
    return this.http.post<Result>(this.baseUrl + 'app/sso',json, {headers} );
  }
 
  
  public async GetTokenJWT(body :any ): Promise<any>{
    const headers = { 
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin':'*'
     };
    const json = JSON.stringify(body);
    const response = this.http.post<any>(this.baseUrl + 'Authenticate/GetLoginToken',json,{headers}).toPromise();
    return response;
  }

  public async post_async(body: any): Promise<any> {
    const jwt = localStorage.getItem('jwt')
    const headers = { 
          'Content-Type': 'application/json',
          'Authorization':'Bearer '+ jwt
        };

    const json = JSON.stringify(body);   
    const response = this.http.post<Result>(this.baseUrl + 'app/sso',json, {headers} ).toPromise();
    return response;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/rest-model/back.service.ts